import { z } from 'zod';

export const PaymentVendorType = z.enum(['TRUSTLY', 'SWISH', 'STRIPE']);
export type PaymentVendorType = z.infer<typeof PaymentVendorType>;
